import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Building2 } from "lucide-react";
import { BRAND, BRAND_SUB, NAV_LINKS, LOGIN_HREF } from "@/data/content";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-navbar"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-500 ${
        scrolled ? "backdrop-blur-xl bg-ink/80 border-b border-hairline" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-[1400px] px-6 md:px-10 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-brand" className="flex items-center gap-3 group">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-hairline bg-surface text-gold">
            <Building2 size={20} />
          </span>
          <span className="leading-tight">
            <span className="block text-sm md:text-base font-semibold tracking-wide text-sand whitespace-nowrap">
              {BRAND}
            </span>
            <span className="block text-[10px] md:text-xs tracking-[0.2em] uppercase text-gold">
              {BRAND_SUB}
            </span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-9">
          {NAV_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-xs tracking-[0.2em] uppercase text-mist hover:text-sand transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href={LOGIN_HREF}
            data-testid="nav-contact-btn"
            className="text-xs tracking-[0.18em] uppercase text-ink bg-gold rounded-full px-5 py-3 hover:bg-sand transition-colors duration-300"
          >
            Kurumsal İş Yönetimi
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          aria-label="Menüyü aç/kapat"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-sand p-2"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-menu"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="md:hidden overflow-hidden border-t border-hairline bg-ink/95 backdrop-blur-xl"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="text-sm tracking-[0.2em] uppercase text-mist hover:text-sand"
                >
                  {l.label}
                </a>
              ))}
              <a
                href={LOGIN_HREF}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.2em] uppercase text-gold"
              >
                Kurumsal İş Yönetimi
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
